import React from 'react';
import Layout from '../components/layout';
import Seo from '../components/seo';
import Cookies from '../components/cookie';
import img from '../images/eldbjorg.jpeg';
import Main from '../components/Main';

const IndexPage = () => (
	<Layout>
		<Seo
			description="En intim og eksklusiv opplevelsesreise med høydepunktene fra Hemsingfestivalen samt overnatting, mat, natur og kultur fra Valdres."
			image={img}
		/>
		<Main />
		<Cookies />
	</Layout>
);

export default IndexPage;
